import axios from 'axios';

import { HttpService } from '@/data/http/http-service';
import { createUuid } from '@/ui/utils/generate-uuid';

import { UploadImageService } from './upload-image-service';

export class UploadImageServiceS3 implements UploadImageService {
  constructor(private destinationFolder: string) {}

  async upload(file: File) {
    const remoteFilePath = buildFilePath(this.destinationFolder, file);
    const signedUploadUrl = await getUploadSignedUrl(remoteFilePath, file);
    await uploadFile(signedUploadUrl, file);
    const sentImageUrl = getImageUploadedUrlFromSignedUrl(signedUploadUrl);
    return sentImageUrl;
  }
}

async function getUploadSignedUrl(remoteFilePath: string, file: File) {
  const httpProject = new HttpService({
    baseURL: import.meta.env.VITE_API_PROJECT,
  });
  const url = '/uploader/signed';
  const data = {
    key: remoteFilePath,
    contentType: file.type,
  };
  const response = await httpProject.post(url, data);
  const signedUploadUrl = response.data.url;
  return signedUploadUrl;
}

async function uploadFile(signedUploadUrl: string, file: File) {
  await axios.put(signedUploadUrl, file, {
    headers: {
      'Content-Type': file.type,
    },
  });
}

function buildFilePath(destinationFolder: string, file: File) {
  const extension = file.type.split('/')[1];
  const filename = createUuid();
  return `orgs/${destinationFolder}/${filename}.${extension}`;
}

function getImageUploadedUrlFromSignedUrl(url: string) {
  const imageUrl = url.split('?')[0];
  return imageUrl;
}
